const theme = {
  body_background_color: '#fdfbf5',
  card_background_color: '#fdfbf5',

  footer_img_top: 'ebj/baspage.webp',

  logo_image_url: 'ebj/hautpage.webp',
  logo_height: 300,

  button_text_color: '#00034c',
  button_color: '#84b9ea',
  button_hover_color: '#e5f4ff',
  button_no_border: true,
  button_radius: 25,

  button_outlined_text_color: '#00034c',
  button_outlined_hover_text_color: '#00034c',
  button_outlined_color: '#84b9ea',

  token_hidden: true,

  title_font: `LotoQc`,
  title_weight: 700,
  title_color: '#00034c',
  title_centered: false,
  title_size: 24,

  subtitle_font: `LotoQc`,
  subtitle_weight: 500,
  subtitle_color: '#00034c',
  subtitle_size: 21,

  subtitleH3_font_weight: 400,
  subtitleH3_font_size: '18',

  text_font: `LotoQc`,
  text_weight: 400,
  text_color: '#00034c',

  framed_background: '#00034C',
  framed_background_text: '#FFFFFF',

  separator_color: '#1912A4',

  lock_background_color: '#00034C',
  lock_background_text_color: '#FFFFFF',
  lock_background_border_radius: 10,
  input_label_color: '#FFFFFF',
  lock_font: 'LotoQc',
  lock_label_weight: 400,

  framed_text_centered: true,

  footer_background_color: '#00034c',
  footer_text_color: '#FFFFFF',
  footer_use_white_logo: true,
  footer_border_hidden: true,

  placeholder_color_1: '#0577d9',
}

export const ebj_english = {
  name: "Thème Bien Jouer Anglais",
  body_background_color: '#fdfbf5',
  card_background_color: '#fdfbf5',

  footer_img_top: 'ebj/baspage_en.webp',

  logo_image_url: 'ebj/hautpage_en.webp',
  logo_height: 300,

  button_text_color: '#00034c',
  button_color: '#84b9ea',
  button_hover_color: '#e5f4ff',
  button_no_border: true,
  button_radius: 25,

  button_outlined_text_color: '#00034c',
  button_outlined_hover_text_color: '#00034c',
  button_outlined_color: '#84b9ea',

  token_hidden: true,

  title_font: `LotoQc`,
  title_weight: 700,
  title_color: '#00034c',
  title_centered: false,
  title_size: 24,

  subtitle_font: `LotoQc`,
  subtitle_weight: 500,
  subtitle_color: '#00034c',
  subtitle_size: 21,

  subtitleH3_font_weight: 400,
  subtitleH3_font_size: '18',

  text_font: `LotoQc`,
  text_weight: 400,
  text_color: '#00034c',

  framed_background: '#00034C',
  framed_background_text: '#FFFFFF',

  separator_color: '#1912A4',

  lock_background_color: '#00034C',
  lock_background_text_color: '#FFFFFF',
  lock_background_border_radius: 10,
  input_label_color: '#FFFFFF',
  lock_font: 'LotoQc',
  lock_label_weight: 400,

  framed_text_centered: true,

  footer_background_color: '#00034c',
  footer_text_color: '#FFFFFF',
  footer_use_white_logo: true,
  footer_border_hidden: true,

  placeholder_color_1: '#0577d9',
}

export default theme